<template>
  <v-card flat>
    <v-toolbar dense flat tile color="white">
      <v-btn depressed small color="primary" :disabled="!podeAdicionar" @click="adicionar">Adicionar Conta a Receber</v-btn>
      <v-btn icon small class="ml-2" @click="listar" :loading="carregando">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-data-table
        mobile-breakpoint="0"
        hide-default-footer
        disable-pagination
        disable-sort
        fixed-header
        no-data-text="Para adicionar uma conta clique no botão adicionar conta a receber"
        height="383px"
        :headers="headers"
        :items="lancamentos"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.descricao }}</td>
            <td>{{ item.data_vencimento | dataBR }}</td>
            <td class="text-right">{{ item.valor | valorBR }}</td>
            <td>{{ formaPagamentoText(item.forma_pagamento) }}</td>
            <td>
              <v-chip small dark :color="statusColor(item.status)">
                {{ statusText(item.status) }}
              </v-chip>
            </td>
            <td class="text-center">
              <v-btn icon @click="editar(item)" class="ma-0">
                <v-icon>{{ item.status === 'quitado' ? 'mdi-eye' : 'mdi-pencil' }}</v-icon>
              </v-btn>
              <v-btn icon @click="quitar(item)" :disabled="item.status === 'quitado'" class="ma-0">
                <v-icon>mdi-check-circle</v-icon>
              </v-btn>
              <v-btn icon @click="estornar(item)" :disabled="item.status === 'pendente'" class="ma-0">
                <v-icon>mdi-undo</v-icon>
              </v-btn>
              <v-btn icon @click="perguntarExcluir(item)" class="ma-0">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>

    <z-dialogo-sim-nao ref="dialogoRemover" titulo="Remover Conta a Receber" botaoSim="Remover" botaoNao="Cancelar" :loading="excluindo">
      A conta a receber será removida desta ordem de serviço.
    </z-dialogo-sim-nao>

    <v-form ref="formulario" v-model="form_valido" lazy-validation>
      <z-dialogo ref="dialogoAdicionar" largura="980px" titulo="Conta a Receber" dividers persistent>
        <template v-slot:conteudo>
          <v-row dense>
            <v-col cols="12" sm="2">
              <z-text-field v-model="lancamento.ordem_servico_id" label="Número OS" readonly />
            </v-col>
            <v-col cols="12" sm="4">
              <z-text-field v-model="clienteNome" label="Cliente" readonly />
            </v-col>
            <v-col cols="12" sm="6">
              <z-text-field v-model="lancamento.descricao" label="Descrição" placeholder=" " :rules="[regras.campoObrigatorio]" :disabled="visualizandoLancamentoQuitado" />
            </v-col>

            <v-col cols="12" sm="6">
              <z-select
                label="Categoria"
                :items="categoriasFiltradas"
                item-text="nome"
                item-value="id"
                v-model="lancamento.categoria_id"
                :rules="[regras.campoObrigatorio]"
                :disabled="visualizandoLancamentoQuitado"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <z-select
                label="Conta financeira"
                :items="contasFinanceiras"
                item-text="nome"
                item-value="id"
                v-model="lancamento.conta_financeira_id"
                :rules="[regras.campoObrigatorio]"
                :disabled="visualizandoLancamentoQuitado"
              />
            </v-col>

            <v-col cols="12" sm="3">
              <z-campo-valor v-model="lancamento.valor" label="Valor" placeholder=" " :rules="[regras.maiorQueZero]" :disabled="visualizandoLancamentoQuitado" />
            </v-col>
            <v-col cols="12" sm="3">
              <z-select
                label="Forma de pagamento"
                :items="$globals.FORMAS_DE_PAGAMENTO"
                item-text="text"
                item-value="value"
                v-model="lancamento.forma_pagamento"
                clearable
                :disabled="visualizandoLancamentoQuitado"
              />
            </v-col>
            <v-col cols="12" sm="3">
              <z-date-picker-menu left label="Data lançamento" v-model="lancamento.data_lancamento" :rules="[regras.campoObrigatorio]" :disabled="visualizandoLancamentoQuitado" />
            </v-col>
            <v-col cols="12" sm="3">
              <z-date-picker-menu left label="Data vencimento" v-model="lancamento.data_vencimento" :rules="[regras.campoObrigatorio]" :disabled="visualizandoLancamentoQuitado" />
            </v-col>

            <v-col cols="12" sm="3">
              <z-select label="Status" :items="statusOpcoes" item-text="text" item-value="value" v-model="lancamento.status" :disabled="visualizandoLancamentoQuitado" />
            </v-col>
            <v-col cols="12" sm="3">
              <z-select label="Modo de geração" :items="origemOpcoes" item-text="text" item-value="value" v-model="lancamento.origem" :disabled="!!lancamento.id || visualizandoLancamentoQuitado" />
            </v-col>
            <v-col cols="12" sm="3" v-if="lancamento.origem !== 'unico'">
              <z-text-field type="number" v-model="lancamento.quantidade" label="Quantidade" placeholder=" " :rules="[regras.campoObrigatorio]" :disabled="visualizandoLancamentoQuitado" />
            </v-col>
            <v-col cols="12" sm="3" v-if="lancamento.origem === 'recorrente'">
              <z-select label="Periodicidade" :items="periodicidadeOpcoes" item-text="text" item-value="value" v-model="lancamento.periodicidade" :disabled="visualizandoLancamentoQuitado" />
            </v-col>
            <v-col cols="12" sm="12">
              <z-textarea v-model="lancamento.observacao" label="Observação" placeholder=" " :disabled="visualizandoLancamentoQuitado" />
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions_right>
          <v-btn text @click="$refs.dialogoAdicionar.fechar()" :disabled="salvando">{{ visualizandoLancamentoQuitado ? 'Fechar' : 'Cancelar' }}</v-btn>
          <v-btn v-if="!visualizandoLancamentoQuitado" color="primary" @click="confirmar" :loading="salvando" :disabled="!form_valido">Confirmar</v-btn>
        </template>
      </z-dialogo>
    </v-form>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import categoriasApi from '@/app/services/financeiro/categorias';
import contasApi from '@/app/services/financeiro/contasfinanceiras';
import lancamentosApi from '@/app/services/financeiro/lancamentos';
import { clone, hoje } from '@/app/helpers/utils';
import * as regras from '@/app/helpers/validacoes';

const lancamentoPadrao = {
  id: '',
  tipo: 'receber',
  descricao: '',
  categoria_id: null,
  conta_financeira_id: null,
  cliente_id: null,
  ordem_servico_id: null,
  valor: null,
  forma_pagamento: null,
  data_lancamento: null,
  data_vencimento: null,
  status: 'pendente',
  data_hora_quitacao: null,
  observacao: '',
  origem: 'unico',
  quantidade: 1,
  periodicidade: 'mensal',
};

export default {
  name: 'TabContasReceber',
  data() {
    return {
      headers: [
        { text: 'Descrição', value: 'descricao' },
        { text: 'Vencimento', value: 'data_vencimento', width: '130px' },
        { text: 'Valor', value: 'valor', width: '120px', align: 'right' },
        { text: 'Forma', value: 'forma_pagamento', width: '170px' },
        { text: 'Status', value: 'status', width: '110px' },
        { text: 'Opções', value: '', width: '190px', align: 'center' },
      ],
      lancamentos: [],
      lancamento: clone(lancamentoPadrao),
      categorias: [],
      contasFinanceiras: [],
      carregando: false,
      salvando: false,
      excluindo: false,
      form_valido: true,
      regras: { ...regras },
      statusOpcoes: [
        { text: 'Pendente', value: 'pendente' },
        { text: 'Quitado', value: 'quitado' },
      ],
      origemOpcoes: [
        { text: 'Único', value: 'unico' },
        { text: 'Parcelado', value: 'parcelado' },
        { text: 'Recorrente', value: 'recorrente' },
      ],
      periodicidadeOpcoes: [
        { text: 'Diário', value: 'diario' },
        { text: 'Semanal', value: 'semanal' },
        { text: 'Mensal', value: 'mensal' },
        { text: 'Anual', value: 'anual' },
      ],
    };
  },
  computed: {
    ...mapState('ordemservico', ['ordemservico']),
    clienteNome() {
      return this.ordemservico.cliente ? this.ordemservico.cliente.nome : '';
    },
    categoriasFiltradas() {
      return this.categorias.filter((item) => item.tipo_aplicacao === 'ambos' || item.tipo_aplicacao === 'receber');
    },
    totalOrdemServico() {
      return Number(this.ordemservico.total_liquido || this.ordemservico.total_orcamento || 0);
    },
    podeAdicionar() {
      return this.totalOrdemServico > 0;
    },
    visualizandoLancamentoQuitado() {
      return !!this.lancamento.id && this.lancamento.status === 'quitado';
    },
  },
  async mounted() {
    await this.carregarAuxiliares();
    await this.listar();
  },
  methods: {
    async carregarAuxiliares() {
      const [categorias, contas] = await Promise.all([
        categoriasApi.listar({ itemsPerPage: 200 }),
        contasApi.listar({ itemsPerPage: 200 }),
      ]);

      this.categorias = categorias.data || [];
      this.contasFinanceiras = contas.data || [];
    },
    async listar() {
      if (!this.ordemservico.id) {
        this.lancamentos = [];
        return;
      }

      this.carregando = true;
      try {
        const response = await lancamentosApi.listar({
          tipo: 'receber',
          ordem_servico_id: this.ordemservico.id,
          itemsPerPage: 200,
        });
        this.lancamentos = response.data || [];
      } finally {
        this.carregando = false;
      }
    },
    adicionar() {
      if (!this.podeAdicionar) {
        this.$eventbus.notificarErro('O total da ordem de serviço deve ser maior que zero para lançar uma conta a receber.');
        return;
      }

      if (!this.ordemservico.cliente_id) {
        this.$eventbus.notificarErro('Informe o cliente da ordem de serviço antes de lançar a conta a receber.');
        return;
      }

      const contaPadrao = this.contasFinanceiras.find((conta) => conta.padrao);
      const categoriaPadrao = this.categoriasFiltradas[0] || null;
      const dataAtual = hoje();

      this.lancamento = {
        ...clone(lancamentoPadrao),
        descricao: `OS ${this.ordemservico.id} - ${this.clienteNome || 'Cliente'}`,
        categoria_id: categoriaPadrao ? categoriaPadrao.id : null,
        conta_financeira_id: contaPadrao ? contaPadrao.id : null,
        cliente_id: this.ordemservico.cliente_id,
        ordem_servico_id: this.ordemservico.id,
        valor: this.totalOrdemServico,
        data_lancamento: dataAtual,
        data_vencimento: dataAtual,
      };

      this.abrirDialogo();
    },
    async editar(item) {
      this.lancamento = {
        ...clone(lancamentoPadrao),
        ...(await lancamentosApi.abrir(item.id)),
        quantidade: 1,
        periodicidade: item.periodicidade || 'mensal',
      };
      this.abrirDialogo();
    },
    abrirDialogo() {
      this.$refs.dialogoAdicionar.abrir();
      this.$nextTick(() => {
        this.$refs.formulario.resetValidation();
      });
    },
    async confirmar() {
      if (!this.$refs.formulario.validate()) {
        return;
      }

      try {
        this.salvando = true;
        this.lancamento.tipo = 'receber';
        this.lancamento.cliente_id = this.ordemservico.cliente_id;
        this.lancamento.ordem_servico_id = this.ordemservico.id;

        if (this.lancamento.status === 'quitado' && !this.lancamento.data_hora_quitacao) {
          this.lancamento.data_hora_quitacao = new Date().toISOString().slice(0, 19).replace('T', ' ');
        }

        if (this.lancamento.id) {
          await lancamentosApi.atualizar(this.lancamento);
        } else {
          await lancamentosApi.salvar(this.lancamento);
        }

        this.$refs.dialogoAdicionar.fechar();
        this.$eventbus.notificar('Conta a receber salva com sucesso.');
        await this.listar();
      } catch (error) {
        this.$eventbus.notificarErro('Não foi possível salvar a conta a receber.', error);
      } finally {
        this.salvando = false;
      }
    },
    async quitar(item) {
      await lancamentosApi.quitar(item.id, new Date().toISOString().slice(0, 19).replace('T', ' '));
      await this.listar();
      this.$eventbus.notificar('Conta a receber marcada como quitada.');
    },
    async estornar(item) {
      await lancamentosApi.estornar(item.id);
      await this.listar();
      this.$eventbus.notificar('Conta a receber estornada.');
    },
    async perguntarExcluir(item) {
      const resposta = await this.$refs.dialogoRemover.abrir();

      if (resposta === true) {
        this.excluindo = true;
        await lancamentosApi.excluir(item.id);
        this.excluindo = false;
        this.$refs.dialogoRemover.fechar();
        this.$eventbus.notificar('Conta a receber removida com sucesso.');
        await this.listar();
      }
    },
    formaPagamentoText(value) {
      const item = this.$globals.FORMAS_DE_PAGAMENTO.find((forma) => forma.value === value);
      return item ? item.text : '-';
    },
    statusText(value) {
      const item = this.statusOpcoes.find((status) => status.value === value);
      return item ? item.text : value;
    },
    statusColor(value) {
      if (value === 'quitado') {
        return 'green';
      }

      if (value === 'pendente') {
        return 'orange';
      }

      return 'grey';
    },
  },
  watch: {
    'ordemservico.id'() {
      this.listar();
    },
  },
};
</script>
